module.exports = __webpack_public_path__ + "static/2019-fineArt2-9a0aa60e4eea34a8617c61822312f783.jpg";